import React, { useState, useEffect } from "react";
import "../../../../assets/scss/home.scss";
import "../../../../assets/scss/tests.scss";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Card } from "reactstrap";
import x_mark from "../../../../assets/images/courses/group.svg";
import Spinner from "../../../../@core/components/spinner/Fallback-spinner";
import PaginatedItemsFlashcard from "../../../../components/tables/paginationResultFlashcard";
import Repository from "../../../../configs/axios/repository";
import { useSelector } from "react-redux";
import { filterFlashcardJson } from "../../../../utility/helpers/filterJson";
import { useLocation, useHistory } from "react-router-dom";
import ProgressBar from "@ramonak/react-progress-bar";
import logo from "@src/assets/images/smartStudyLogo.svg";
import Swal from "sweetalert2";

const ResultFlashcard = (props) => {
    const location = useLocation();
    const history = useHistory();
    const isInvateValue = useSelector((state) => state.layout.isInvate);
    let getFlashcard = localStorage.getItem("getFlashcard");
    let flashCardData = JSON.parse(getFlashcard);
    const testType = location.state?.testType;
    let array = location.state?.array;
    let isData = location.state?.isData;
    let flashId = location.state?.flashId;
    let noteData = location.state?.noteData;
    let flashcard_id = location.state?.flashcard_id;
    let scoreResult = location.state?.scoreResult;
    let note_id = localStorage.getItem("note_id");

    const [loadingData, setLoadingData] = useState(true);
    const [showProblem, setShowProblem] = useState(false);
    const [resultData, setResultData] = useState("");
    const [showTiket, setShowTiket] = useState();
    const [showCources, setShowCources] = useState(true);
    const [collCount, setCollCount] = useState(0);

    let count = 1;
    let processValue = 10;
    const process = () => {
        if (count < 10) {
            setLoadingData(false);
            count = count + 1;
            processValue = processValue + 10;
            setCollCount(processValue);
            hendleSubmit();
        } else {
            setCollCount(100);
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "There is something wrong with the prompt. Please change it and try again.!",
            }).then((result) => {
                if (result.isConfirmed) {
                    let notes = flashCardData.notes;
                    history.push({
                        pathname: "/tests",
                        state: {
                            note_id,
                            notes,
                            testType,
                            noteData,
                        },
                    });
                }
                setLoadingData(true);
            });
        }
    };

    const toaccountingTestPage = () => {
        localStorage.setItem("isCreate", false);
        history.push({
            pathname: "/accountingFlashcard",
            state: { array, flashCardData, flashcard_id, noteData },
        });
    };

    function checkTypeTest(count) {
        return `Flashcard - ${count} Questions`;
    }
    function score() {
        let countRightAnswer = 0;
        for (let i = 0; i < array.length; i++) {
            if (array[i].correct == true) {
                countRightAnswer = countRightAnswer + 1;
            }
        }

        return `Your Score: ${
            countRightAnswer +
            "/" +
            array.length +
            " (" +
            Math.floor((100 * countRightAnswer) / array.length) +
            "%)"
        }`;
    }
    const hendleSubmit = async () => {
        setLoadingData(false);
        setTimeout(() => {
            setCollCount(processValue);
        }, 1000);
        const result = await Repository.postRequest(
            `api/flashcards/getChatCompletion`,
            { messages: flashCardData.notes }
        );
        setResultData(result?.data?.data.getChatCompletionData);
        if (result.status === 200 || result.status === 201) {
            const array = filterFlashcardJson(result.data);
            if (array == "error") {
                process();
            } else {
                setCollCount(100);

                setTimeout(() => {
                    toaccountingTestPage();
                }, 2000);
            }
        }
    };
    const redoFlashcard = () => {
        localStorage.setItem("isCreate", false);
        history.push({
            pathname: "/accountingFlashcard",
            state: { array, testType, flashCardData, flashcard_id, noteData },
        });
    };

    async function updateFlashcardIsResultState() {
        let result = await Repository.postRequest(
            `api/flashcards/updateFlashcardIsResult`,
            { id: flashId, is_result: true }
        );
    }

    useEffect(() => {
        updateFlashcardIsResultState();
        if (isData == true) {
            localStorage.setItem("showTiketTest", false);
            setShowTiket(false);
        } else {
            let isDatas = localStorage.getItem("showTiketFlashcard");
            if (isDatas == "true" || isDatas == null || isDatas == undefined) {
                setShowTiket(true);
                localStorage.setItem("showTiketFlashcard", true);
            } else {
                setShowTiket(false);
            }
        }
    }, []);

    useEffect(() => {
        setShowCources(isInvateValue);
    }, [isInvateValue]);

    return loadingData ? (
        showProblem ? (
            <div>
                <Card className="cardSection">
                    <CardBody className="cardBodiDiv">
                        <div>{resultData}</div>
                    </CardBody>
                </Card>
            </div>
        ) : (
            <div>
                <Card className="mt-4 resultCard">
                    <div>
                        <div className="resultHeader">
                            <h1>Results</h1>

                            <img
                                src={x_mark}
                                alt="x_mark"
                                onClick={() => {
                                    let notes = flashCardData?.notes;
                                    history.push({
                                        pathname: "/home",
                                    });
                                    //  history.push({
                                    //     pathname: "/flashcards",
                                    //     state: { note_id, notes, noteData },
                                    // });
                                }}
                            />
                        </div>
                    </div>

                    <div className="accountingHeaderContentresulttest">
                        <h1>{flashCardData?.flashcard_name}</h1>
                    </div>
                    <div className="testType">
                        <div>
                            <span>{checkTypeTest(array.length)}</span>
                        </div>
                    </div>
                    <div className="accountingHeaderContentresulttest">
                        <h1>{score()}</h1>
                    </div>
                    <div className="buttonsDivResult">
                        <button
                            className="finish"
                            onClick={() => {
                                let notes = flashCardData?.notes;
                                history.push({
                                    pathname: "/home",
                                    state: { note_id, notes, noteData },
                                });
                            }}
                        >
                            Finish
                        </button>
                        <button
                            onClick={() => {
                                redoFlashcard();
                            }}
                        >
                            Re-take
                        </button>
                        {/* {showCources ? (
                            ""
                        ) : (
                            <button
                                onClick={() => {
                                    hendleSubmit();
                                }}
                            >
                                Re-generate
                            </button>
                        )} */}
                    </div>

                    <div className=" pgItems ">
                        <PaginatedItemsFlashcard
                            itemsPerPage={4}
                            items={array}
                            scoreResult={scoreResult}
                            flashId={flashId}
                            isCreate={true}
                        />
                    </div>
                </Card>
            </div>
        )
    ) : (
        <div>
            <div className="fallback-spinner app-loader progres">
                <img className="fallback-logo" src={logo} alt="logo" />
                <div className="loading loadingDiv">
                    <div className="effect-1 effects"></div>
                    <div className="effect-2 effects"></div>
                    <div className="effect-3 effects"></div>
                </div>
                <ProgressBar completed={collCount} />
            </div>
        </div>
    );
};

export default ResultFlashcard;
